import React from "react";
import Retreats2 from "./Retreats2";

function RetreatsPage() {
  return (
    <div>
        <div className="max-w-7xl mx-auto bg-white">
          <header className="flex justify-between items-center p-4 md:p-6 ">
            <img
              src="https://i0.wp.com/plumvillage.org/wp-content/uploads/2019/07/plumvillage-black.png?fit=646%2C166&ssl=1" // Bạn cần thay thế bằng đường dẫn logo chính xác
              alt="Plum Village Logo"
              className="h-10 md:h-12"
            />
          </header>
    
          <div className="flex flex-col md:flex-row">
            {/* Sidebar */}
            {/* <aside className="w-full md:w-1/4 p-4 md:p-6 ">
              <nav className="space-y-2 md:space-y-4">
                <a href="#" className="block font-semibold text-gray-900">
                  Retreats
                </a>
                <a href="#" className="block text-yellow-600 font-semibold">
                  Retreats Calendar
                </a>
                <a href="#" className="block text-gray-400">
                  Volunteering
                </a>
                <a href="#" className="block text-gray-400">
                  About Plum Village Retreats
                </a>
                <a href="#" className="block text-gray-400">
                  Days of Mindfulness
                </a>
                <a href="#" className="block text-gray-400">
                  Extended Stay at Plum Village
                </a>
              </nav>
            </aside> */}
    
            {/* Main Content */}
            <main className="w-full md:w-3/4 p-4 md:p-8">
              <h1 className="text-2xl md:text-3xl font-semibold text-gray-800">
                Retreats 
              </h1>
              <p className="mt-4 text-base md:text-lg text-gray-700">
                Below you can find our upcoming  retreats hosted
                by Thai Plum Village monasteries around the world.
                Registration is open 3 days before start day
              </p>
           
             
              
            </main>
          </div>
          <Retreats2/>
          </div>
    </div>
  );
}

export default RetreatsPage;
